export default "__VITE_ASSET__BoMmp7fK__"